<svg
  class="block size-full"
  [attr.width]="width ?? size"
  [attr.height]="height ?? size"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 20 20"
>
  <path
    d="M9.6 4V15.2M4 9.6H15.2"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.6"
  ></path>
</svg>
